module.exports = __webpack_public_path__ + "static/media/pinFile.fdb59db2.svg";